import { render, staticRenderFns } from "./BrandDeliverySettings.vue?vue&type=template&id=117f498c"
import script from "./BrandDeliverySettings.vue?vue&type=script&lang=js"
export * from "./BrandDeliverySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports